import { call, put } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { ChangeExtractTaskPriorityAction } from '../../../../extract/services/ChangeExtractTaskPriorityAction';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { Set } from '../../../../ts/models/Set';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { SetExtractRefreshPriorityAction } from '../../../actions/spaces/SetExtractRefreshPriorityAction';

export function* handleSetExtractRefreshPriorityAction(action: SetExtractRefreshPriorityAction) {
  try {
    yield call(executeSetExtractRefreshAction, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeSetExtractRefreshAction(items: IExtractTaskInfo[]) {
  return ChangeExtractTaskPriorityAction.execute(Set.fromIdItemArray(items));
}
